import React from "react";
import { Redirect } from "react-router-dom";
import { handlePostLogin, getUser } from "./AuthenticatedUser";
import { ErrorTypes } from "../../consts/ErrorTypes";
import Configs from "../../Configurations";

function Login({ response, actions: { setError, setUser } }) {
  return handlePostLogin(
    response,
    (landingUrl) => {
      //Redirect to home page or to the last viewed after successful login
      setUser(getUser());
      setError(null);
      return <Redirect to={landingUrl} />;
    },
    (errorType) => {
      if (errorType === ErrorTypes.APP_USER_NOT_AUTHORIZED) {
        const baseUrl = Configs.REACT_APP_SPARK_COMMS_URL;
        if (baseUrl) {
          window.location.href = `${baseUrl}/teams`;
          return null;
        }
      }
      setError(errorType);
      return <Redirect to="/" />;
    }
  );
}
export default Login;
